import React, { useState } from 'react';
import './Modal.css';
import { Calendar } from 'lucide-react';
import Heading6Semibold from '../designSystem/Heading6Semibold';
import BodyMediumRegular from '../designSystem/BodyMediumRegular';
import BodyExtraSmallMedium from '../designSystem/BodyExtraSmallMedium';
import Textarea from '../designSystem/TextArea';

const MarkLeaveModal = ({ isVisible, onClose, selectedDay, onMarkLeave, isLoading }) => {
    const [leaveMessage, setLeaveMessage] = useState('');
    const [error, setError] = useState('');
    const CHARACTER_LIMIT = 150;
    const formatSelectedDate = () => {
        if (!selectedDay?.day) return '';
        const { day, month, year } = selectedDay.day;
        const date = new Date(year, month - 1, day);
        return date.toLocaleDateString('en-US', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    const handleLeaveMessageChange = (e) => {
        const value = e.target.value;
        
        if (value.length > CHARACTER_LIMIT) {
            setError(`Message cannot exceed ${CHARACTER_LIMIT} characters`);
            return;
        }
        
        setLeaveMessage(value);
        setError('');
    };

    const handleMarkLeave = () => {
        if (!leaveMessage.trim()) {
            setError('Leave message is required');
            return;
        }

        if (leaveMessage.length > CHARACTER_LIMIT) {
            setError(`Message cannot exceed ${CHARACTER_LIMIT} characters`);
            return;
        }

        onMarkLeave && onMarkLeave({
            day: selectedDay?.day,
            events: selectedDay?.events,
            leaveMessage: leaveMessage.trim()
        });

        setLeaveMessage('');
        setError('');
        onClose();
    };

    const handleClose = () => {
        setLeaveMessage('');
        setError('');
        onClose();
    };

    const handleBackdropClick = (e) => {
        if (e.target.classList.contains('modal-backdrop')) {
            handleClose();
        }
    };
    const handleModalClick = (e) => {
        e.stopPropagation();
    };

    const remainingCharacters = CHARACTER_LIMIT - leaveMessage.length;
    const isNearLimit = remainingCharacters <= 20;
    const isOverLimit = remainingCharacters < 0;

    return (
        isVisible && (
            <div className="modal-backdrop" onClick={handleBackdropClick}>
                <div className="modal-container" onClick={handleModalClick}>
                    <div className="content-container">
                        <div className="icon-container">
                            <Calendar size={24} color="#1E293B" />
                        </div>
                        
                        <div className="text-container">
                            <Heading6Semibold 
                                color="#1E293B" 
                                text="Mark Leave" 
                            />
                            <BodyMediumRegular 
                                color="#374151" 
                                text={`Mark leave for ${formatSelectedDate()}`}
                            />
                            
                            <div className="textarea-wrapper">
                                <Textarea
                                height='100px'
                                    value={leaveMessage}
                                    onChange={handleLeaveMessageChange}
                                    error={error}
                                    placeholder="Enter reason for leave..."
                                />
                                <div className="character-counter">
                                    <BodyExtraSmallMedium 
                                        color={isOverLimit ? "#F23030" : isNearLimit ? "#D97706" : "#6B7280"} 
                                        text={`${leaveMessage.length}/${CHARACTER_LIMIT}`}
                                    />
                                </div>
                            </div>
                            
                            <BodyMediumRegular
                                color="#6B7280"
                                text="Note: Once marked, this will be visible to your manager and reflect in reports. Please ensure the details are accurate."
                            />
                        </div>
                    </div>   
                    <div className="button-contiainer">
                        <button className="cancel-button" onClick={handleClose}>
                            <BodyExtraSmallMedium color="#1E293B" text="Cancel" />
                        </button>
                        <button
                            className="primary-button"
                            onClick={handleMarkLeave}
                            disabled={isLoading || isOverLimit}
                        >
                            <BodyExtraSmallMedium 
                                color="#FFFFFF" 
                                whiteSpace="nowrap"
                                text={isLoading ? "Marking..." : "Mark Leave"} 
                            />
                        </button>
                    </div>
                </div>
            </div>
        )
    );
};

export default MarkLeaveModal;